import GUI_Header from "./GUI_Header";
import GUI_InputTextSingle from "./GUI_InputTextSingle";
import GUI_Credit from "./GUI_Credit";
import T from "../TheTool";

function GUIset_2Input(props) {
	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var guiTxt1 = T.getValue(props.guiTxt1, "");
	var guiTxt2 = T.getValue(props.guiTxt2, "");
	var label1 = T.getValue(props.label1, "Input1");
	var label2 = T.getValue(props.label2, "Input2");
	var numberOnly1 = T.getValue(props.numberOnly1, false);
	var numberOnly2 = T.getValue(props.numberOnly2, false);
	var txtButton = T.getValue(props.txtButton, "Click");
	//------------------------------------------------------------
	var style = T.getValue(props.style, 0);
	var sizeLabel1 = 22;
	var sizeTxt1 = 22;
	var width1_1 = 120;
	var width1_2 = "80%";
	var sizeLabel2 = 22;
	var sizeTxt2 = 22;
	var width2_1 = 120;
	var width2_2 = "80%";
	var but_marginLeft = "16%";
	var but_marginRight = 0;
	if (style == 1) {
		sizeLabel1 = 26;
		sizeTxt1 = 28;
		width1_1 = 120;
		width1_2 = "80%";
		sizeLabel2 = 26;
		sizeTxt2 = 24;
		width2_1 = 120;
		width2_2 = "80%";
		but_marginLeft = "20%";
		but_marginRight = "2%";
	}
	//----
	var width1_custom = T.getValue(props.width1, 0);
	var width2_custom = T.getValue(props.width2, 0);
	if(width1_custom != 0){ width1_1 = width1_custom; width2_1 = width1_custom; }
	if(width2_custom != 0){ width2_1 = width2_custom; width2_2 = width2_custom; }
	//------------------------------
	var headerStyle = T.getValue(props.headerStyle, 1);
	//1 standard, 0 no header, 2 with bullet
	var headerPreBullet = T.getValue(props.headerPreBullet, null);
	var headerBullet = T.getValue(props.headerBullet, []);
	var headerBulletItems = null;
	if (headerBullet.length > 0) {
		headerBulletItems = headerBullet.map((b,i) => <li key={"bullet"+i}>{b}</li>);
	}

	return (
		<div className="todoapp stack-large">
			{/* <GUI_Header title={title1} desc={desc1} /> 
			<div style={{ marginTop: "3em" }}/>  */}
			{headerStyle == 0 ? (
				<div></div>
			) : (
				<GUI_Header title={title1} desc={desc1} desc_v2={props.desc_v2}/>
			)}
			{/* --------------------------------- */}
			{headerPreBullet != null ? <div style={{ alignItems: "right",  fontSize: 19, marginTop: 5}} >{headerPreBullet}</div> : <div></div>}
			{headerBulletItems != null ? (
				<div  style={{ alignItems: "right", paddingLeft: 50, marginTop: 5 , fontSize: 18}}>
						{headerBulletItems}
				</div>
			) : (
				<div></div>
			)}
			{/* --------------------------------- */}
			{headerStyle == 0 ? (
				<div></div>
			) : (
				<div style={{ marginTop: "3em" }}> </div>
			)}
			{/* --------------------------------- */}
			<GUI_InputTextSingle
				label={label1}
				labelsize={sizeLabel1}
				text1={guiTxt1}
				text1Change={props.guiTxtChange1}
				numberOnly={numberOnly1}
				width1={width1_1}
				fontSize2={sizeTxt1}
				width2={width1_2}
			/>
			<GUI_InputTextSingle
				label={label2}
				labelsize={sizeLabel2}
				text1={guiTxt2}
				text1Change={props.guiTxtChange2}
				numberOnly={numberOnly2}
				width1={width2_1}
				fontSize2={sizeTxt2}
				width2={width2_2}
			/>
			<div
				style={{
					display: "flex",
					marginLeft: but_marginLeft,
					marginRight: but_marginRight,
				}}
			>
				<button
					onClick={() => props.buttonClick1()}
					className="btn btn__primary btn__lg"
					style={{ flex: 1, height: 50 }}
				>
					{txtButton}
				</button>
			</div>
			<div style={{ marginTop: "3em" }}> </div>
			{props.partResult}
			<GUI_Credit />
		</div>
	);
}
export default GUIset_2Input;
